import React from 'react';

import ShowAllCollapsible from '~/components/core/Molecules/Collapsible/ShowAllCollapsible';
import Text from '~/components/core/TextComponents/Text';

import { LOG_MESSAGE_VISIBLE_LINES } from '../constants';
import { TEXTS } from '../texts';

interface ClampedTextProps {
  children: string;
  /** Draws the text at full strength, as the handler's own answer is, rather than as a muted note. */
  isPrimary?: boolean;
}

/**
 * A line of a card's body, clamped at the log's four lines. The toggle is lifted over an activity
 * card's click overlay, as a payload value's is, so it opens the text rather than the card's entry in
 * the log.
 */
const ClampedText: React.FC<ClampedTextProps> = ({ children, isPrimary = false }) => (
  <ShowAllCollapsible
    visibleLines={LOG_MESSAGE_VISIBLE_LINES}
    showAsInlineButton
    expandLabel={TEXTS.SHOW_MORE}
    collapseLabel={TEXTS.SHOW_LESS}
    linkClassName="relative z-10"
  >
    <Text
      variant={Text.VARIANTS.SM}
      weight={Text.WEIGHTS.REGULAR}
      colorVariant={isPrimary ? Text.COLOR_VARIANTS.PRIMARY : Text.COLOR_VARIANTS.SECONDARY}
    >
      {children}
    </Text>
  </ShowAllCollapsible>
);

export default ClampedText;
